import { render, staticRenderFns } from "./question-panel.vue?vue&type=template&id=1564c58b&scoped=true&"
import script from "./question-panel.vue?vue&type=script&lang=ts&"
export * from "./question-panel.vue?vue&type=script&lang=ts&"
import style0 from "./question-panel.vue?vue&type=style&index=0&id=1564c58b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564c58b",
  null
  
)

export default component.exports